<template>
    <div class="got-a-question">

        <h2>{{ heading }}</h2>

        <p>{{ description }}</p>

        <ul class="contact-information">
            <li><a :href="'mailto:'+emailAddress" title="" aria-label="" class="email">{{ emailAddress }}</a></li>
            <li><a :href="'tel:'+adjustedPhoneNumber" title="" aria-label="" class="telephone">{{ phoneNumber }}</a></li>
        </ul>

    </div>
</template>

<script type="text/javascript">

export default {
    props: [
        'heading',
        'description',
        'emailAddress',
        'phoneNumber',
    ],

    computed: {
        adjustedPhoneNumber() {
            return this.phoneNumber ? this.phoneNumber.replace(' ', '') : '';
        }
    }
}

</script>
